module.exports = __webpack_public_path__ + "img/invoice_approved.68efa7a2.svg";